<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            Complaints
            <v-spacer></v-spacer>
            <!-- <v-col cols="12" sm="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                solo
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col> -->
            <v-col class="pt-10" cols="6" sm="3">
              <v-select
                :items="items"
                v-model="status"
                label="Status"
                outlined
              ></v-select>
            </v-col>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="user"
            :items-per-page="count"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="complaintinfo(item._id)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
          <div class="pt-2">
            <v-pagination
              :length="page"
              :total-visible="7"
              v-model="currentPage"
            ></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      search: "",
      currentPage: 1,
      ServerError: false,
      page: 1,
      limit: 10,
      count: 10,
      status: null,
      totalData: 0,
      totalRows: 0,
      headers: [
        { text: "Customer Name", value: "customerName" },
        { text: "Mobile", value: "mobile" },
        { text: "Email", value: "email" },
        {text:"Status", value: "status"},
        { text: "Actions", value: "actions", sortable: false },
      ],
      user: [],
      items: ["read", "unread"],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    status() {
      this.getData();
    },
    search() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      var data = {};
      if (this.status !== "") {
        data["status"] = this.status;
      }
      data["page"] = this.currentPage;
      data["limit"] = this.limit;
      axios({
        url: "/complaint/form/list",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    complaintinfo(sid) {
      this.$router.push({ name: "complaintView", params: { cid: sid } });
    },
  },
};
</script>

<style>
</style>